import React, { ReactElement } from "react";
import Modal from "../../shared/components/modal/Modal";
import { FormikProps } from "formik";

import { getFinancieringsbehoefteTextResources } from "../infra/financieringsbehoefte-resources";
import { LabeledCurrencyInput, CurrencyInput, TextInput, BerekenCurrencyInput } from "adviesbox-shared";

import AdviesBoxFormik from "../../shared/utils/adviesbox-formik";
import { InbrengEigenGeldModal as InbrengEigenGeldModalState } from "../infra/financieringsbehoefte-types";
import { inbrengEigenGeldModalSchema } from "../infra/financieringsbehoefte-schema";
import classes from "./inbreng-eigen-geld-modal.module.scss";

export type InbrengEigenGeldModalData = {
  data: InbrengEigenGeldModalState;
};

type InbrengEigenGeldModalProps = {
  onSave?: (data: InbrengEigenGeldModalState) => void;
  closeModal?: () => void;
  gewensteHypotheekBerekenen?: boolean;
};

const InbrengEigenGeldModal = ({
  data,
  onSave,
  closeModal,
  gewensteHypotheekBerekenen
}: InbrengEigenGeldModalData & InbrengEigenGeldModalProps): ReactElement => {
  const body = (values: InbrengEigenGeldModalState, touched: any): ReactElement => {
    return (
      <>
        <div>
          <LabeledCurrencyInput
            labelColSize={6}
            caption="Inbreng eigen geld"
            name="inbrengEigenGeld"
            allowNegative={true}
            readonly={gewensteHypotheekBerekenen === false}
            tooltip={getFinancieringsbehoefteTextResources("TooltipInbrengEigenGeld")}
          />
        </div>
        <LabeledCurrencyInput
          caption="Inbreng voor verlagen restschuld"
          name="inbrengVoorVerlagenRestschuld"
          labelColSize={6}
          readonly={true}
          tooltip={getFinancieringsbehoefteTextResources("TooltipInbrengVoorVerlagenRestschuld")}
        />

        <BerekenCurrencyInput
          caption="Inbreng verwachte overwaarde"
          name="eigenGeldOverwaarde"
          labelColSize={6}
          tooltip={getFinancieringsbehoefteTextResources("TooltipEigengeldOverwaarde")}
        />

        <LabeledCurrencyInput caption="Extra aflossing" name="extraAflossing" labelColSize={6} />

        <div className="form-group form-row">
          <div className="col-6">
            <div className={classes.inbreng_eigen_geld}>
              <TextInput name="inbrengEigengeldOmschrijving1" placeholder="Omschrijving" />
            </div>
          </div>

          <div className="col-6">
            <CurrencyInput name="inbrengEigengeldBedrag1" />
          </div>
        </div>

        <div className="form-group form-row">
          <div className="col-6">
            <div className={classes.inbreng_eigen_geld}>
              <TextInput name="inbrengEigengeldOmschrijving2" placeholder="Omschrijving" />
            </div>
          </div>

          <div className="col-6">
            <CurrencyInput name="inbrengEigengeldBedrag2" />
          </div>
        </div>

        <h2>Inbreng polis / rekening</h2>

        <LabeledCurrencyInput
          labelColSize={6}
          caption="Inbreng opgebouwde waarde"
          name="inbrengOpgebouwdeWaarde"
          readonly={true}
        />

        <div className="form-group form-row">
          <div className="col-6">
            <div className={classes.inbreng_eigen_geld}>
              <TextInput name="inbrengPolisOmschrijving" placeholder="Omschrijving" />
            </div>
          </div>

          <div className="col-6">
            <CurrencyInput name="inbrengPolisBedrag" />
          </div>
        </div>

        <LabeledCurrencyInput
          caption="Waarvan verlagen restschuld"
          name="waarvanVerlagenRestschuld"
          labelColSize={6}
          readonly={true}
          tooltip={getFinancieringsbehoefteTextResources("TooltipInbrengWaarvanVerlagenRestschuld")}
        />
      </>
    );
  };
  return (
    <AdviesBoxFormik<InbrengEigenGeldModalState>
      initialValues={{ ...data }}
      validationSchema={inbrengEigenGeldModalSchema}
      onSave={onSave}
      closeModal={closeModal}
      render={({ values, submitForm, touched, dirty }: FormikProps<InbrengEigenGeldModalState>): ReactElement => (
        <>
          <Modal
            title="Inbreng eigen geld"
            body={body(values, touched)}
            onSubmitClick={submitForm}
            onCancelClick={closeModal}
            isFormDirty={dirty}
          />
        </>
      )}
    />
  );
};

export default InbrengEigenGeldModal;
